module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/modules/_iter-step.js
// module id = Fpfx
// module chunks = 11